module.exports = __webpack_public_path__ + "img/m-banner-vbrohihj-tr-TR.de825e52.jpg";